import {
    createAccordionComponent, IAccordionBusinessLogic,
} from '@vfde-brix/accordion';
import {NO_PATTERN_BUSINESS_LOGIC} from '@vfde-brix/core';

/**
 * Accordion BRIX component
 * @param action
 * @param container
 */
export const mountAccordionStatic = (container: string, onToggle: (accordionItemId?: string, isOpen?: boolean) => void) => {

    const elAccordion = document.getElementById(container);
    if (null !== elAccordion) {
        const businessLogic: IAccordionBusinessLogic = {
            onToggle,
        };
        createAccordionComponent(
            elAccordion,
            businessLogic,
        );
    }
};
